package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.lennycodes.hldi.constants.HLDITheme

val DeveloperCreditLinkStyle = CssStyle {
    base {
        Modifier
            .color(HLDITheme.Colors.white) // or a muted variant if you have one, e.g. mediumGray
            .styleModifier {
                property("text-decoration", "none")
                property("opacity", "0.75")
            }
            .transition(
                Transition.of(
                    property = "opacity",
                    duration = 200.ms,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }
    hover {
        Modifier.styleModifier {
            property("opacity", "1")
            property("text-decoration", "underline")
        }
    }
}